import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceState, PublicConfig } from '@reflex/shared';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/** Admin-panel read of the current maintenance-mode state (`admin:read`). */
export function useMaintenanceState() {
  return useQuery({
    queryKey: queryKeys.maintenance,
    queryFn: api.getMaintenance,
  });
}

/**
 * Admin-panel write of maintenance mode (`admin:manage`). On success we prime
 * both the admin query and the shared `/config` cache so the local session's
 * banner reflects the change immediately; other sessions get the WebSocket push.
 */
export function useSetMaintenanceMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (state: MaintenanceState) => api.setMaintenance(state),
    onSuccess: (state) => {
      queryClient.setQueryData(queryKeys.maintenance, state);
      queryClient.setQueryData<PublicConfig>(queryKeys.config, (prev) =>
        prev ? { ...prev, maintenance: state } : prev,
      );
    },
  });
}
